import React from 'react';
import { Hero } from '../components/Hero';
import { LocalTrust } from '../components/LocalTrust';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
export function Home() {
  return <main data-id="element-1449">
      <Hero data-id="element-1450" />
      <LocalTrust data-id="element-1451" />
      <Services data-id="element-1452" />
      <HowItWorks data-id="element-1453" />
      <FAQ data-id="element-1454" />
      <Reviews data-id="element-1455" />
    </main>;
}